<div class="card-wrap recc-card" (click)="openInNewTab(travelCardInfo)">
  <div class="card travel-card paid-card text-left">
      <div class="clip-img card-variant">
          <!-- <img *ngIf="(classOrProgramInfo?.image?.path || classOrProgramInfo?.image?.name || classOrProgramInfo?.thumbnailUrl)" [src]="classOrProgramInfo?.thumbnailUrl ? classOrProgramInfo?.thumbnailUrl : imageUrl+classOrProgramInfo?.image?.path + classOrProgramInfo?.image?.name "  class="card-img-top" alt="card image" />
          <img *ngIf="!(classOrProgramInfo?.image?.path || classOrProgramInfo?.image?.name) &&  !classOrProgramInfo?.thumbnailUrl" src=""  class="card-img-top" alt="card image" /> -->
          <img  [src]="baseUrl?.images + travelCardInfo?.defaultImage?.path + travelCardInfo?.defaultImage?.name" alt="card image" class="card-img-top" >
          
          <!-- <span class="clip-icn">
              <img src="assets/images/video-icon.png" alt="video-icon"/>
          </span> -->
         
          <!-- for programs -->
          <p  class="info info-desc">
              <span  class="time" >
                  {{ travelCardInfo?.categoryName }}
              </span>
          </p>
          <!-- <span class="clip-tagtxt">
              Recommended
          </span> -->
          <!-- <span class="card-heart-icn" >
              <img src="assets/images/heart-icn-white.png" alt="">
          </span> -->
      </div>
      <div class="card-body">
          <div class="schedule">
              <p class="card-text">
                  {{ travelCardInfo?.name }}
              </p>
              <!-- <span class="lavel"><img [src]="classOrProgramInfo?.level ? 'assets/images/'+classOrProgramInfo?.level+'.png' : 'assets/images/6.png'" alt="graph" /> 
                  {{classOrProgramInfo?.level}}
              </span> -->
          </div>
          <div class="location-cal">
            <p class="desc-txt">
                <span class="icn">
                    <img src="assets/images/location-icn.png" alt="">
                </span>
                <!-- Canyon Ranch Woodside, California, United States -->
                {{ travelCardInfo?.cityId }}
                {{ ( travelCardInfo?.cityId && travelCardInfo?.state && travelCardInfo?.country?.name ) ? ', ': '' }}
                {{ travelCardInfo?.state }}
                {{  (travelCardInfo?.state && travelCardInfo?.country?.name) ? ', ': '' }}
                {{ travelCardInfo?.country?.name }}
            </p>
            <p class="desc-txt">
                <span class="icn">
                    <img src="assets/images/calender-icn.png" alt="">
                </span>
                <!-- Available All Year Round  -->
                {{ travelCardInfo?.scheduleDurationDate}}
            </p>
          </div>
          <p class="duration-pkg">
              From {{ travelCardInfo?.minimumStayDuration }} days/ {{ (travelCardInfo?.minimumStayDuration - 1) }} nights
            </p>
          <p class="pkg-price">
              <sup class="sign">$</sup> 
              <!-- 1,075  -->
              {{ travelCardInfo?.minPrice }}
              <sup class="points">00</sup> 
              <sub>pp</sub>
          </p>
      </div>
  </div>
</div>